






































































import Vue from 'vue';
import { sso, WIRED_COMMUTE_API_SUB_URLS } from '@/api';
import { EventBus } from '@/event-bus';
import { MemberAccountResponseModel } from '@/@types/member';
import { ExtendMixins } from '@/services';
import { OpenHelp } from '@/mixins';

interface Data {
  clickedBtnId: boolean;
  viewInfoBtnId: string;
  ssoUrl: string;
  formData: any;
}

export default ExtendMixins(OpenHelp).extend({
  name: 'AccountsOverview',
  props: {
    accounts: {
      type: Array as () => MemberAccountResponseModel[],
      required: true,
    },
  },
  data(): Data {
    return {
      clickedBtnId: false,
      viewInfoBtnId: '',
      ssoUrl: '',
      formData: {},
    };
  },
  mounted() {
    EventBus.$on('wired-commute-sso', this.closeHelpAndSSO);
  },
  computed: {
    getMemberId(): string {
      return this.$store.getters.user.memberId;
    },
  },
  methods: {
    showLoading(ssoBtnId): boolean {
      return ssoBtnId === this.clickedBtnId;
    },
    isDisabled(ssoBtnId): boolean {
      return this.clickedBtnId && ssoBtnId !== this.clickedBtnId;
    },
    getWiredCommuteSSO(ssoBtnId): void {
      this.clickedBtnId = ssoBtnId;
      const memberId = this.getMemberId;
      sso
        .post(`${WIRED_COMMUTE_API_SUB_URLS.wiredCommuteSso}/${memberId}/wired-commute-federations`)
        .then((response) => {
          this.ssoUrl = response.data.url;
          this.formData = response.data.formData;

          this.$nextTick(() => {
            (this.$refs.sso as any).submit();
          });
        })
        .catch(() => {
          this.clickedBtnId = false;

          EventBus.$emit('openModal', 'Error', {
            message: 'wired-commute_sso-redirect-error_unable-to-perform-redirect',
          });
        });
    },
    openHelpTray(template, viewInfoBtnId): void {
      this.viewInfoBtnId = viewInfoBtnId;
      this.openHelp(template);
    },
    closeHelpAndSSO(): void {
      EventBus.$emit('closeHelp');
      this.getWiredCommuteSSO(this.viewInfoBtnId);
    },
  },
});
